export default "__VITE_ASSET___19ZTOPB8V4o6vl1IEDd0w__";